<section class="financiamiento-section">
    <div class="financiamiento-overlay"></div>
    <div class="hero-container">
        <h1 class="hero-title animate-hero-title">
            Financiamiento de Mercados y Capitales
        </h1>
    </div>
</section>

<section class="services-detail-section" #servicesSection>
    <div class="container">
        <div class="services-detail-content">
            <!-- Columna izquierda: Texto + Imagen -->
            <div class="services-left">
                <h2 class="services-intro animate-on-scroll" [class.visible]="isVisible" style="--delay: 0s">
                    Diseñamos la mejor estrategia para obtener financiamiento y optimizar el costo del capital.
                </h2>
                <div class="services-image animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.2s">
                    <img src="/assets/Tarjetas servicios/1 Financ mercado.jpg"
                        alt="Financiamiento y Mercado de Capitales">
                </div>
            </div>
            <!-- Columna derecha: Lista de servicios -->
            <div class="services-right">
                <ul class="services-list">
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.3s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Apertura de cuenta comitente en ALyCs habilitados por CNV.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.4s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Asesoramiento sobre instrumentos financieros.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.5s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Negociación de eCheqs, Pagarés Bursátiles.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.6s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Descuento de Facturas de Crédito Electrónicas.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.7s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Armado de carpetas para avales de SGR.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.8s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Financiamiento bancario y no bancario.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.9s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Emisión de Obligaciones Negociables PyME.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 1s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Estrategia de estructura de deuda.</span>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</section>
<app-cta-section></app-cta-section>